<template>
    <!-- <a-flex :style="{ height: windowHeight }" > -->
	<a-flex :style="{ height: `${windowHeight}px` }">
        <a-flex span="24" :md="10" :lg="8">
            <a-flex vertical justify="center" class="centered-form">
                <div style="text-align: center">
                    <img :src=logo class="col-img">
                </div>
				<div v-if="MaintanceFlag == false">
					<div style="text-align: center">
						<h3 class="title_login">{{ title_login }}</h3>				
					</div>
					<FormLogin @handleLoading="(loading, message) => $emit('handleLoading', loading, message)" :typeLogin="typeLogin" />
				</div>
				<div v-else>
					<Maintance></Maintance>
				</div>
			</a-flex>
        </a-flex>
		<a-col ref="colRef" span="0" :md="14" :lg="16" >
			<BackgroundLogin :colRef="colRef"></BackgroundLogin>
		</a-col>
    </a-flex>
</template>
<script> 
import FormLogin from '../components/login/FormLogin.vue';
import AliadoLogin from './Netplus/AliadoComercial.vue'
import Maintance from '../components/login/Maintance.vue';
import BackgroundLogin from '../components/Widgets/BackgroundLogin.vue';
export default ({
	components: {
		FormLogin,
		AliadoLogin,
		BackgroundLogin,
		Maintance
	},
	props: {
    	getWindowHeight: {
     		type: Function,
      		required: true,
    	},
		footerHeight: {
			type: String,
			required: true
		}
  	},
	data() {
		return {
			// Binded model property for "Sign In Form" switch button for "Remember Me" .
			logo: this.$route.meta.logo,
			rememberMe: true,
			windowHeight: 0,
			showAlert: false,
			colRef: this.$refs.colRef,
			MaintanceFlag: false,
			typeLogin: null,
			title_login: "Zona Cliente Netplus"
		}
	},
	mounted() {
		this.loadLoginType()
		this.colRef = this.$refs.colRef;
		this.$nextTick(this.setupResizeListener);
	},
	methods: {
		setupResizeListener() {
			this.handleResize(); // Llamamos al método inicialmente para establecer el tamaño de fondo
			window.addEventListener('resize', this.handleResize);
		},
		removeResizeListener() {
			window.removeEventListener('resize', this.handleResize);
		},
		handleResize() {		
            this.windowHeight = window.innerHeight;
		},
		loadLoginType() {
			switch(this.$route.fullPath) {
				case "/aliado_comercial":
					this.typeLogin = "aliado_comercial";
					this.title_login = "Aliado Comercial Netplus";
					break;
				default:
					this.typeLogin = "default";
					this.title_login = "Zona Cliente Netplus";
					break;
			}
		}
	}
})
</script>
<style lang="scss" src="@/scss/layouts/login.scss" />
